import React, { useEffect, useState } from "react";
import api from "../lib/api";

export default function Audit() {
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get("/audit").then(r => setRows(r.data)); }, []);

  return (
    <div className="p-6 space-y-4" data-testid="audit-root">
      <div>
        <div className="section-label">Governance</div>
        <h1 className="text-2xl font-bold tracking-tight mt-1">Audit Trail</h1>
        <p className="text-sm text-ink-soft">Every measurement & report action is logged with user, timestamp and detail.</p>
      </div>

      <div className="card overflow-hidden">
        <table className="dense">
          <thead><tr><th>Timestamp</th><th>User</th><th>Action</th><th>Target</th><th>Details</th></tr></thead>
          <tbody>
            {rows.map(r => (
              <tr key={r.id} data-testid={`audit-${r.id}`}>
                <td className="font-mono text-xs">{r.ts}</td>
                <td>{r.user}</td>
                <td className="font-mono text-xs">{r.action}</td>
                <td className="font-mono text-xs">{r.target}</td>
                <td className="text-xs text-ink-soft">{JSON.stringify(r.details)}</td>
              </tr>
            ))}
            {rows.length===0 && <tr><td colSpan={5} className="text-center text-ink-soft py-6">No audit events yet — submit a measurement or upload to see entries.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
